import React, { useState, useEffect, useContext } from 'react';
import './SalesStyles.css';
import { currency, Flex, Flexed, Input, MainWrap, Scroll } from '../../utilities/Shared';
import { PLSSalesReps } from '../../utilities/Reps';
import Select from 'react-select'
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { sortdate, sortit, sortnum, sortshippingcustomer } from '../../utilities/Sort';
import axios from 'axios';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import UserContext from '../../Context/UserContext';
import Wip from '../../Printing/Wip';

const SalesDashboard = () => {

const {userInfo} = useContext(UserContext)
const param = useParams()

console.log(userInfo)
  const [salesreps, setSalesreps] = useState([])
  const [selectedsalesrep, setSelectedsalesrep] = useState();

  const [search, setSearch] = useState('')
  const [jobs, setJobs] = useState([])
  const [alljobs, setAllJobs] = useState([])
  const [allJobsStartDate, setAllJobsStartDate] = useState(null);
  const [allJobsEndDate, setAllJobsEndDate] = useState(null);

  // Current year (original state names)
  const [thisWeekTotal, setThisWeekTotal] = useState(0);
  const [lastWeekTotal, setLastWeekTotal] = useState(0);
  const [thisMonthTotal, setThisMonthTotal] = useState(0);
  const [thisQuarterTotal, setThisQuarterTotal] = useState(0);
  const [thisYearTotal, setThisYearTotal] = useState(0);

  // Last year
  const [lastYearThisWeek, setLastYearThisWeek] = useState(0);
  const [lastYearLastWeek, setLastYearLastWeek] = useState(0);
  const [lastYearThisMonth, setLastYearThisMonth] = useState(0);
  const [lastYearThisQuarter, setLastYearThisQuarter] = useState(0);
  const [lastYearYTD, setLastYearYTD] = useState(0);

  // Two years ago
  const [twoYearsAgoThisWeek, setTwoYearsAgoThisWeek] = useState(0);
  const [twoYearsAgoLastWeek, setTwoYearsAgoLastWeek] = useState(0);
  const [twoYearsAgoThisMonth, setTwoYearsAgoThisMonth] = useState(0);
  const [twoYearsAgoThisQuarter, setTwoYearsAgoThisQuarter] = useState(0);
  const [twoYearsAgoYTD, setTwoYearsAgoYTD] = useState(0);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [activeJobNumbers, setActiveJobNumbers] = useState([]);
  const [activeops, setActiveops] = useState([]);
  const [openrfq, setOpenrfq] = useState([]);
  const [quotes, setQuotes] = useState([]);

  // Sorting states for each table
  const [activeSort, setActiveSort] = useState({ column: null, direction: 'asc' });
  const [rfqSort, setRfqSort] = useState({ column: null, direction: 'asc' });
  const [allJobsSort, setAllJobsSort] = useState({ column: null, direction: 'asc' });
  const [quotesSort, setQuotesSort] = useState({ column: null, direction: 'asc' });

  const year = new Date().getFullYear()
  const nav = useNavigate()

  // Sorting handler
  const handleSort = (table, column) => {
    const sortState = table === 'active' ? activeSort :
                     table === 'rfq' ? rfqSort :
                     table === 'alljobs' ? allJobsSort :
                     quotesSort;

    const setSort = table === 'active' ? setActiveSort :
                    table === 'rfq' ? setRfqSort :
                    table === 'alljobs' ? setAllJobsSort :
                    setQuotesSort;

    if (sortState.column === column) {
      setSort({
        column,
        direction: sortState.direction === 'asc' ? 'desc' : 'asc'
      });
    } else {
      setSort({ column, direction: 'asc' });
    }
  };

  // Sorting helper function
  const getSortedData = (data, sortConfig) => {
    if (!sortConfig.column) return data;

    return [...data].sort((a, b) => {
      let valA = a[sortConfig.column] ?? '';
      let valB = b[sortConfig.column] ?? '';

      // Date fields
      if (sortConfig.column === 'dateentered' || 
          sortConfig.column === 'duedate' || 
          sortConfig.column === 'entered') {
        valA = new Date(valA || 0);
        valB = new Date(valB || 0);
        return sortConfig.direction === 'asc' ? valA - valB : valB - valA;
      }

      // Numeric fields
      if (sortConfig.column === 'quantity') {
        valA = parseFloat(valA) || 0;
        valB = parseFloat(valB) || 0;
        return sortConfig.direction === 'asc' ? valA - valB : valB - valA;
      }

      // String comparison (job, quote, customer, custpo, etc.)
      valA = String(valA).toLowerCase();
      valB = String(valB).toLowerCase();
      
      return sortConfig.direction === 'asc'
        ? valA.localeCompare(valB)
        : valB.localeCompare(valA);
    });
  };


  useEffect(() => {
    const getsalesreps = async() => {
      let h = await PLSSalesReps()
      const opts = h.map(cust => ({
        value: cust._id,
        label: cust.firstName+' '+cust.lastName.substr(0,1),
        customer: cust
      }));
      setSalesreps(opts)
    }
    getsalesreps()
  },[])



  useEffect(() => {

  if (salesreps.length > 0 && userInfo?._id && !selectedsalesrep) {
    const foundRep = salesreps.find(rep => rep.value === userInfo?._id);
    
    if (foundRep) {
      setSelectedsalesrep(foundRep);
    }
  }
}, [salesreps, param?.id, selectedsalesrep]);
  const getActiveJobs = async (salesrep) => {
    let rep = { rep: salesrep };
    try {
      //const response = await axios.post('http://localhost:5001/jobs/findactivejobs', rep);
       const response = await axios.post('https://highgroundapi.herokuapp.com/jobs/findactivejobs', rep);
      const jobData = response.data || [];
      setJobs(jobData);

      const jobNumbers = jobData
        .map(job => job.job)
        .filter(Boolean)
        .map(String);
      setActiveJobNumbers(jobNumbers);
      console.log('Active job numbers extracted:', jobNumbers);
    } catch (error) {
      console.error('Error fetching active jobs:', error);
      setJobs([]);
      setActiveJobNumbers([]);
    }
  };

  const config = {
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*'
    }
  };

  const getrfq = async(salesrep) => {
    try {
      let opsResponse = await axios.post(
        'https://highgroundsoftware.com/dash/dashboard/php/newgetrfq.php',
        { salesrep: salesrep},
        config
      );
      setOpenrfq(opsResponse.data || [])
      console.log('rfq Response:', opsResponse.data);
    } catch (err) {
      console.error('RFQ fetch error:', err);
    }
  }

  const getquotes = async(salesrep) => {
    try {
      let opsResponse = await axios.post(
        'https://highgroundsoftware.com/dash/dashboard/php/newgetquotes.php',
        { salesrep: salesrep},
        config
      );
      setQuotes(opsResponse.data || [])
      console.log('Quote Response:', opsResponse.data);
    } catch (err) {
      console.error('Quotes fetch error:', err);
    }
  }

  const getallJobs = async(salesrep) => {
    let rep = {rep:salesrep}
    try {
      const alljobs = await axios.post('https://highgroundapi.herokuapp.com/jobs/findalljobsbysalesrep', rep)
      console.log(alljobs.data)
      setAllJobs(alljobs.data.sort(function(a, b) { return parseInt(b.job) - parseInt(a.job)}))
    } catch (err) {
      console.error('All jobs fetch error:', err);
    }
  }

  useEffect(() => {
    const getops = async () => {
      if (activeJobNumbers.length === 0) return;
      try {
        const opsResponse = await axios.post(
          'https://highgroundsoftware.com/dash/dashboard/php/getoperations.php',
          { jobs: activeJobNumbers },
          config
        );
        setActiveops(opsResponse.data || [])
        console.log('Operations Response for Schedules:', opsResponse.data);
      } catch (err) {
        console.error('Operations fetch error:', err);
      }
    }
    getops()
  }, [activeJobNumbers])

  // useEffect(() => {
  //   let findemp = salesreps.find(emp => emp?.value === param?.id)
  //   setSelectedsalesrep(findemp)
  // },[salesreps])

  useEffect(() => {
    if (selectedsalesrep?.customer?.empId) {
      getActiveJobs(selectedsalesrep?.customer?.empId)
      getallJobs(selectedsalesrep?.customer?.empId)
      getrfq(selectedsalesrep?.customer?.empId)
      getquotes(selectedsalesrep?.customer?.empId)
    }
  },[selectedsalesrep])

  // ──────────────────────────────────────────────────────────────────────────────
  // Date range helpers (unchanged)
  // ──────────────────────────────────────────────────────────────────────────────
  function cleanAndParseCost(cost) {
    if (cost == null) return 0;
    const cleaned = String(cost).replace(/[^0-9.-]+/g, '');
    const num = parseFloat(cleaned);
    return isNaN(num) ? 0 : num;
  }

  function calculateTotalBillable(jobs) {
    return jobs.reduce((total, job) => {
      if (!Array.isArray(job.billable)) return total;
      return total + job.billable.reduce((sum, bill) => {
        return sum + cleanAndParseCost(bill.cost);
      }, 0);
    }, 0);
  }

  const billable = (jobs) => {
    if (!jobs?.length) return 0;
    let total = 0;
    jobs.forEach((jobItem) => {
      total += cleanAndParseCost(jobItem?.cost);
    });
    return total;
  };

  const calculatePercentChange = (current, previous) => {
    if (previous === 0) {
      return current > 0 ? "+∞%" : "0%";
    }
    const change = ((current - previous) / previous) * 100;
    const sign = change > 0 ? "+" : change < 0 ? "-" : "";
    const absValue = Math.abs(change).toFixed(0);
    return `${sign}${absValue}%`;
  };

  const getChangeDisplay = (current, previous) => {
    if (previous === 0) return current > 0 ? "↑ ∞%" : "—";
    const pct = ((current - previous) / previous) * 100;
    const abs = Math.abs(pct).toFixed(0);
    if (pct > 0) return `↑ ${abs}%`;
    if (pct < 0) return `↓ ${abs}%`;
    return "—";
  };

  function getThisWeekRange() {
    const now = new Date();
    const dayOfWeek = now.getDay();
    const start = new Date(now);
    start.setDate(now.getDate() - dayOfWeek);
    start.setHours(0, 0, 0, 0);
    const end = new Date(start);
    end.setDate(start.getDate() + 6);
    end.setHours(23, 59, 59, 999);
    return { start, end };
  }

  function getLastWeekRange() {
    const thisWeek = getThisWeekRange();
    const start = new Date(thisWeek.start);
    start.setDate(thisWeek.start.getDate() - 7);
    const end = new Date(thisWeek.end);
    end.setDate(thisWeek.end.getDate() - 7);
    return { start, end };
  }

  function getThisMonthRange() {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), 1);
    const end = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999);
    return { start, end };
  }

  function getThisQuarterRange() {
    const now = new Date();
    const quarter = Math.floor(now.getMonth() / 3);
    const startMonth = quarter * 3;
    const start = new Date(now.getFullYear(), startMonth, 1);
    const end = new Date(now.getFullYear(), startMonth + 3, 0, 23, 59, 59, 999);
    return { start, end };
  }

  const shiftRangeToYear = (range, targetYear) => {
    const start = new Date(range.start);
    start.setFullYear(targetYear);
    const end = new Date(range.end);
    end.setFullYear(targetYear);
    return { start, end };
  };

  // ──────────────────────────────────────────────────────────────────────────────
  // Sales calculation (unchanged)
  // ──────────────────────────────────────────────────────────────────────────────
  useEffect(() => {
    const fetchAndCalculateSales = async () => {
      if (!selectedsalesrep?.customer?.empId) return;
      try {
        setLoading(true);
        const response = await axios.post(
          `https://highgroundapi.herokuapp.com/jobs/getyearlyjobs`,
          { rep: selectedsalesrep?.customer?.empId }
        );
        const allYearJobs = response.data;

        const currentThisWeek = getThisWeekRange();
        const currentLastWeek = getLastWeekRange();
        const currentThisMonth = getThisMonthRange();
        const currentThisQuarter = getThisQuarterRange();

        setThisWeekTotal(calculateTotalBillable(allYearJobs.filter(j => {
          const d = new Date(j.createdAt); return d >= currentThisWeek.start && d <= currentThisWeek.end;
        })));
        setLastWeekTotal(calculateTotalBillable(allYearJobs.filter(j => {
          const d = new Date(j.createdAt); return d >= currentLastWeek.start && d <= currentLastWeek.end;
        })));
        setThisMonthTotal(calculateTotalBillable(allYearJobs.filter(j => {
          const d = new Date(j.createdAt); return d >= currentThisMonth.start && d <= currentThisMonth.end;
        })));
        setThisQuarterTotal(calculateTotalBillable(allYearJobs.filter(j => {
          const d = new Date(j.createdAt); return d >= currentThisQuarter.start && d <= currentThisQuarter.end;
        })));
        setThisYearTotal(calculateTotalBillable(allYearJobs.filter(j => new Date(j.createdAt).getFullYear() === year)));

        const lyThisWeek = shiftRangeToYear(currentThisWeek, year-1);
        const lyLastWeek = shiftRangeToYear(currentLastWeek, year-1);
        const lyThisMonth = shiftRangeToYear(currentThisMonth, year-1);
        const lyThisQuarter = shiftRangeToYear(currentThisQuarter, year-1);

        setLastYearThisWeek(calculateTotalBillable(allYearJobs.filter(j => {
          const d = new Date(j.createdAt); return d >= lyThisWeek.start && d <= lyThisWeek.end;
        })));
        setLastYearLastWeek(calculateTotalBillable(allYearJobs.filter(j => {
          const d = new Date(j.createdAt); return d >= lyLastWeek.start && d <= lyLastWeek.end;
        })));
        setLastYearThisMonth(calculateTotalBillable(allYearJobs.filter(j => {
          const d = new Date(j.createdAt); return d >= lyThisMonth.start && d <= lyThisMonth.end;
        })));
        setLastYearThisQuarter(calculateTotalBillable(allYearJobs.filter(j => {
          const d = new Date(j.createdAt); return d >= lyThisQuarter.start && d <= lyThisQuarter.end;
        })));
        setLastYearYTD(calculateTotalBillable(allYearJobs.filter(j => new Date(j.createdAt).getFullYear() === year-1)));

        const tyThisWeek = shiftRangeToYear(currentThisWeek, year-2);
        const tyLastWeek = shiftRangeToYear(currentLastWeek, year-2);
        const tyThisMonth = shiftRangeToYear(currentThisMonth, year-2);
        const tyThisQuarter = shiftRangeToYear(currentThisQuarter, year-2);

        setTwoYearsAgoThisWeek(calculateTotalBillable(allYearJobs.filter(j => {
          const d = new Date(j.createdAt); return d >= tyThisWeek.start && d <= tyThisWeek.end;
        })));
        setTwoYearsAgoLastWeek(calculateTotalBillable(allYearJobs.filter(j => {
          const d = new Date(j.createdAt); return d >= tyLastWeek.start && d <= tyLastWeek.end;
        })));
        setTwoYearsAgoThisMonth(calculateTotalBillable(allYearJobs.filter(j => {
          const d = new Date(j.createdAt); return d >= tyThisMonth.start && d <= tyThisMonth.end;
        })));
        setTwoYearsAgoThisQuarter(calculateTotalBillable(allYearJobs.filter(j => {
          const d = new Date(j.createdAt); return d >= tyThisQuarter.start && d <= tyThisQuarter.end;
        })));
        setTwoYearsAgoYTD(calculateTotalBillable(allYearJobs.filter(j => new Date(j.createdAt).getFullYear() === year-2)));

        setLoading(false);
      } catch (err) {
        console.error('Error:', err);
        setError('Failed to load sales data');
        setLoading(false);
      }
    };
    fetchAndCalculateSales();
  }, [selectedsalesrep]);


  console.log(userInfo?._id)
   console.log(jobs)
  return (
    <MainWrap>
      <Flexed style={{margin:'30px 0px'}}>
        <Flex style={{fontSize:'2rem'}}> {selectedsalesrep?.label} DashBoard </Flex>
        <Flex>
         {userInfo.departments?.some(cat => cat.value === "106") || userInfo.departments?.some(cat => cat.value === "101") ?
          <Select
            options={salesreps}
            value={salesreps.find(o => o.value === selectedsalesrep?.value) || null}
            onChange={(opt) => {
              if (!opt) { setSelectedsalesrep({}); return; }
              const cust = opt;
              setSelectedsalesrep(cust);
            }}
            placeholder="Search customer..."
            isClearable
          />:
          null
        }
        </Flex>
      </Flexed>

      <Tabs>
        <TabList>
          <Tab>Active Jobs - {jobs.length}</Tab>
          <Tab>Open RFQ's - {openrfq.length}</Tab>
          <Tab>All Jobs - {alljobs.length}</Tab>
          <Tab>All Quotes - {quotes.length}</Tab>
          <Tab>Sales Report</Tab>
        </TabList>

        {/* Active Jobs Tab */}
        <TabPanel>
          <Flexed padding="10px 0px 0px 0px">
            <Flex><Input type="text" height="30px" placeholder="Search Work In Progress" value={search} onChange={e => setSearch(e.target.value)}/></Flex>
            <Wip 
      jobs={getSortedData(jobs, activeSort)
              .filter(jobinfo => {
                if (!search) return true;
                const term = search.toLowerCase();
                return (
                  String(jobinfo?.job || '').toLowerCase().includes(term) ||
                  String(jobinfo?.customer || '').toLowerCase().includes(term) ||
                  String(jobinfo?.custpo || '').toLowerCase().includes(term) ||
                  String(jobinfo?.jobname || '').toLowerCase().includes(term) ||
                  String(jobinfo?.quantity || '').toLowerCase().includes(term)
                );
              })}
      activeops={activeops}
      selectedsalesrep={selectedsalesrep}
      buttonText="Print Active Jobs"
    />
          </Flexed>

          <Flexed 
            bgColor="#8398AB" 
            height='20pt' 
            color="white" 
            font-size='11pt' 
            display="flex" 
            alignItems='center' 
            margin="25px 0px" 
            padding='5px'
            style={{ cursor: 'pointer' }}
          >
            <Flex onClick={() => handleSort('active', 'job')}>Job #</Flex>
            <Flex flex="2" onClick={() => handleSort('active', 'customer')}>Customer</Flex>
            <Flex flex=".7" onClick={() => handleSort('active', 'quantity')}>Quantity</Flex>
            <Flex flex="2" onClick={() => handleSort('active', 'jobname')}>Job Name</Flex>
            <Flex onClick={() => handleSort('active', 'dateentered')}>Enter Date</Flex>
            <Flex onClick={() => handleSort('active', 'duedate')}>Due Date</Flex>
            <Flex onClick={() => handleSort('active', 'custpo')}>PO#</Flex>
            <Flex onClick={() => handleSort('active', 'status')}>Status</Flex>
            <Flex></Flex>
          </Flexed>

          <Scroll height="60vh" style={{border:'1px solid lightgray'}}>
            {getSortedData(jobs, activeSort)
              .filter(jobinfo => {
                if (!search) return true;
                const term = search.toLowerCase();
                return (
                  String(jobinfo?.job || '').toLowerCase().includes(term) ||
                  String(jobinfo?.customer || '').toLowerCase().includes(term) ||
                  String(jobinfo?.custpo || '').toLowerCase().includes(term) ||
                  String(jobinfo?.jobname || '').toLowerCase().includes(term) ||
                  String(jobinfo?.quantity || '').toLowerCase().includes(term)
                );
              })
              .map(jobinfo => {
                const matchingOp = activeops.find(op => String(op.job) === String(jobinfo.job));
                const opName = matchingOp ? matchingOp.name : 'On Incoming';

                return (
                  <Flexed padding="6px " key={jobinfo._id} className="hand normalrow" >
                    <Flex onClick={e => nav(`/jobticket/good/${jobinfo?.job}`)}>{jobinfo?.job}</Flex>
                    <Flex flex="2" >{jobinfo?.customer}</Flex>
                    <Flex flex=".7" >{jobinfo?.quantity}</Flex>
                      <Flex flex="2" >{jobinfo?.jobname}</Flex>
                    <Flex >{new Date(jobinfo?.dateentered).toLocaleDateString('en-US')}</Flex>
                    <Flex >{new Date(jobinfo?.duedate).toLocaleDateString('en-US')}</Flex>
                    <Flex >{jobinfo?.custpo}</Flex>
                    <Flex>{opName}</Flex>
                    <Flex></Flex>
                  </Flexed>
                );
              })}
          </Scroll>
          <br/>
        </TabPanel>

        {/* Open RFQ's Tab */}
        <TabPanel>
          <Flexed padding="10px 0px 0px 0px">
            <Flex><Input type="text" height="30px" placeholder="Search RFQ" value={search} onChange={e => setSearch(e.target.value)}/></Flex>
          </Flexed>

          <Flexed 
            bgColor="#8398AB" 
            height='20pt' 
            color="white" 
            font-size='11pt' 
            display="flex" 
            alignItems='center' 
            margin="25px 0px" 
            padding='5px'
            style={{ cursor: 'pointer' }}
          >
            <Flex onClick={() => handleSort('rfq', 'quote')}>RFQ #</Flex>
            <Flex flex="2" onClick={() => handleSort('rfq', 'customer')}>Customer</Flex>
            <Flex flex="2" onClick={() => handleSort('rfq', 'quantity')}>Quantity</Flex>
            <Flex onClick={() => handleSort('rfq', 'entered')}>Enter Date</Flex>
            <Flex></Flex>
          </Flexed>

          <Scroll height="60vh" style={{border:'1px solid lightgray'}}>
            {getSortedData(openrfq, rfqSort)
              .filter(jobinfo => {
                if (!search) return true;
                const term = search.toLowerCase();
                return (
                  String(jobinfo?.quote || '').toLowerCase().includes(term) ||
                  String(jobinfo?.customer || '').toLowerCase().includes(term) ||
                  String(jobinfo?.custpo || '').toLowerCase().includes(term) ||
                  String(jobinfo?.jobname || '').toLowerCase().includes(term) ||
                  String(jobinfo?.quantity || '').toLowerCase().includes(term)
                );
              })
              .map(jobinfo => (
                <Flexed padding="6px " key={jobinfo._id} className="hand normalrow" >
                  <Flex >{jobinfo?.quote}</Flex>
                  <Flex flex="2" >{jobinfo?.customer}</Flex>
                  <Flex flex="2" >{jobinfo?.quantity}</Flex>
                  <Flex >{new Date(jobinfo?.entered).toLocaleDateString('en-US')}</Flex>
                  <Flex ></Flex>
                </Flexed>
              ))
            }
          </Scroll>
          <br/>
        </TabPanel>

        {/* All Jobs Tab */}
        <TabPanel>
          <Flexed padding="10px 0px 0px 0px" style={{ alignItems: 'center', gap: '15px' }}>
            <Flex flex="1">
              <Input
                value={search}
                type="text"
                height="30px"
                placeholder="Search All Jobs"
                onChange={e => setSearch(e.target.value)}
              />
            </Flex>
           
            <Flex style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <DatePicker
                selected={allJobsStartDate}
                onChange={(date) => setAllJobsStartDate(date)}
                selectsStart
                startDate={allJobsStartDate}
                endDate={allJobsEndDate}
                placeholderText="Start Date"
                dateFormat="MM/dd/yyyy"
                isClearable
                showPopperArrow={false}
                customInput={<Input height="30px" style={{ width: '140px' }} />}
              />
              <span style={{ color: '#666' }}>to</span>
              <DatePicker
                selected={allJobsEndDate}
                onChange={(date) => setAllJobsEndDate(date)}
                selectsEnd
                startDate={allJobsStartDate}
                endDate={allJobsEndDate}
                minDate={allJobsStartDate}
                placeholderText="End Date"
                dateFormat="MM/dd/yyyy"
                isClearable
                showPopperArrow={false}
                customInput={<Input height="30px" style={{ width: '140px' }} />}
              />
            </Flex>
          </Flexed>

          <Flexed 
            bgColor="#8398AB" 
            height='20pt' 
            color="white" 
            font-size='11pt' 
            display="flex" 
            alignItems='center' 
            margin="25px 0px" 
            padding='5px'
            style={{ cursor: 'pointer' }}
          >
            <Flex onClick={() => handleSort('alljobs', 'job')}>Job #</Flex>
            <Flex flex="2" onClick={() => handleSort('alljobs', 'customer')}>Customer</Flex>
            <Flex flex=".7" onClick={() => handleSort('alljobs', 'quantity')}>Quantity</Flex>
               <Flex flex="2" onClick={() => handleSort('alljobs', 'jobname')}>Job Name</Flex>
            <Flex onClick={() => handleSort('alljobs', 'dateentered')}>Enter Date</Flex>
            <Flex onClick={() => handleSort('alljobs', 'duedate')}>Due Date</Flex>
            <Flex onClick={() => handleSort('alljobs', 'custpo')}>PO#</Flex>
            <Flex></Flex>
            <Flex></Flex>
          </Flexed>

          <Scroll height="60vh" style={{border:'1px solid lightgray'}}>
            {getSortedData(alljobs, allJobsSort)
              .filter(jobinfo => {
                if (search) {
                  const term = search.toLowerCase();
                  const matchesText =
                    String(jobinfo?.job || '').toLowerCase().includes(term) ||
                    String(jobinfo?.customer || '').toLowerCase().includes(term) ||
                    String(jobinfo?.custpo || '').toLowerCase().includes(term) ||
                    String(jobinfo?.jobname || '').toLowerCase().includes(term) ||
                    String(jobinfo?.quantity || '').toLowerCase().includes(term);
                  if (!matchesText) return false;
                }
                if (allJobsStartDate || allJobsEndDate) {
                  const jobDate = new Date(jobinfo?.dateentered);
                  if (isNaN(jobDate)) return false;
                  if (allJobsStartDate && jobDate < allJobsStartDate) return false;
                  if (allJobsEndDate) {
                    const end = new Date(allJobsEndDate);
                    end.setHours(23, 59, 59, 999);
                    if (jobDate > end) return false;
                  }
                }
                return true;
              })
              .map(jobinfo => (
                <Flexed padding="6px " key={jobinfo._id} className="hand normalrow" >
                  <Flex onClick={e => nav(`/jobticket/good/${jobinfo?.job}`)}>{jobinfo?.job}</Flex>
                  <Flex flex="2" >{jobinfo?.customer}</Flex>
                  <Flex flex=".7" >{jobinfo?.quantity}</Flex>
                     <Flex flex="2" >{jobinfo?.jobname}</Flex>
                  <Flex >{new Date(jobinfo?.dateentered).toLocaleDateString('en-US')}</Flex>
                  <Flex >{new Date(jobinfo?.duedate).toLocaleDateString('en-US')}</Flex>
                  <Flex >{jobinfo?.custpo}</Flex>
                  <Flex></Flex>
                  <Flex>
                    {jobinfo?.billable?.length <= 0
                      ? jobinfo.currentprice
                      : currency(billable(jobinfo.billable))
                    }
                  </Flex>
                </Flexed>
              ))
            }
          </Scroll>
          <br/>
        </TabPanel>

        {/* All Quotes Tab */}
        <TabPanel>
          <Flexed padding="10px 0px 0px 0px" style={{ alignItems: 'center', gap: '15px' }}>
            <Flex flex="1">
              <Input
                value={search}
                type="text"
                height="30px"
                placeholder="Search Quotes"
                onChange={e => setSearch(e.target.value)}
              />
            </Flex>
           
            <Flex style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <DatePicker
                selected={allJobsStartDate}
                onChange={(date) => setAllJobsStartDate(date)}
                selectsStart
                startDate={allJobsStartDate}
                endDate={allJobsEndDate}
                placeholderText="Start Date"
                dateFormat="MM/dd/yyyy"
                isClearable
                showPopperArrow={false}
                customInput={<Input height="30px" style={{ width: '140px' }} />}
              />
              <span style={{ color: '#666' }}>to</span>
              <DatePicker
                selected={allJobsEndDate}
                onChange={(date) => setAllJobsEndDate(date)}
                selectsEnd
                startDate={allJobsStartDate}
                endDate={allJobsEndDate}
                minDate={allJobsStartDate}
                placeholderText="End Date"
                dateFormat="MM/dd/yyyy"
                isClearable
                showPopperArrow={false}
                customInput={<Input height="30px" style={{ width: '140px' }} />}
              />
            </Flex>
          </Flexed>

          <Flexed 
            bgColor="#8398AB" 
            height='20pt' 
            color="white" 
            font-size='11pt' 
            display="flex" 
            alignItems='center' 
            margin="25px 0px" 
            padding='5px'
            style={{ cursor: 'pointer' }}
          >
            <Flex onClick={() => handleSort('quotes', 'quote')}>Quote #</Flex>
            <Flex flex="2" onClick={() => handleSort('quotes', 'customer')}>Customer</Flex>
            <Flex flex="2" onClick={() => handleSort('quotes', 'quantity')}>Quantity</Flex>
            <Flex onClick={() => handleSort('quotes', 'entered')}>Enter Date</Flex>
            <Flex></Flex>
          </Flexed>

          <Scroll height="60vh" style={{border:'1px solid lightgray'}}>
            {getSortedData(quotes, quotesSort)
              .filter(jobinfo => {
                if (search) {
                  const term = search.toLowerCase();
                  const matchesText =
                    String(jobinfo?.job || '').toLowerCase().includes(term) ||
                    String(jobinfo?.customer || '').toLowerCase().includes(term) ||
                    String(jobinfo?.custpo || '').toLowerCase().includes(term) ||
                    String(jobinfo?.jobname || '').toLowerCase().includes(term) ||
                    String(jobinfo?.quantity || '').toLowerCase().includes(term);
                  if (!matchesText) return false;
                }
                if (allJobsStartDate || allJobsEndDate) {
                  const jobDate = new Date(jobinfo?.dateentered);
                  if (isNaN(jobDate)) return false;
                  if (allJobsStartDate && jobDate < allJobsStartDate) return false;
                  if (allJobsEndDate) {
                    const end = new Date(allJobsEndDate);
                    end.setHours(23, 59, 59, 999);
                    if (jobDate > end) return false;
                  }
                }
                return true;
              })
              .map(jobinfo => (
                <Flexed padding="6px " key={jobinfo._id} className="hand normalrow" >
                  <Flex onClick={() => nav(`/quote/letter/${jobinfo?.quote}`)}>{jobinfo?.quote}</Flex>
                  <Flex flex="2" >{jobinfo?.customer}</Flex>
                  <Flex flex="2" >{jobinfo?.quantity}</Flex>
                  <Flex >{new Date(jobinfo?.entered).toLocaleDateString('en-US')}</Flex>
                  <Flex ></Flex>
                </Flexed>
              ))
            }
          </Scroll>
          <br/>
        </TabPanel>

        {/* Sales Report Tab - unchanged */}
        <TabPanel>
       {userInfo?._id === selectedsalesrep?.value || userInfo?.departments?.some(cat => cat.value === "106") ? <>
       
        <Flexed gap='20px' style={{position:"relative"}} bgColor="#8398AB" color="white" font-size='1.3rem' display="flex" alignItems='center' padding='5px' marginTop='40px'>
            <Flex style={{fontSize:'1.3rem'}}>{year} Sales    </Flex>
            <Flex style={{fontSize:'1.3rem'}}>{year -1} Sales</Flex>
          </Flexed>

          <div style={{padding:"0px 0px",position:"relative"}}>
            <Flexed gap='20px' style={{border:'1px solid gray',paddingTop:'10px'}}>
              <Flex>
                <Flexed style={{padding:'5px 0px',fontSize:'1.3rem'}}>
                  <Flex style={{}}>This Week</Flex>
                  <Flex textAlign='left'>{currency(thisWeekTotal)}</Flex>
                  <Flex style={{
                    color: thisWeekTotal > lastYearThisWeek ? 'green' :
                           thisWeekTotal < lastYearThisWeek ? 'red' : 'gray'
                  }}>
                    {getChangeDisplay(thisWeekTotal, lastYearThisWeek)}
                  </Flex>
                </Flexed>
                <Flexed style={{padding:'5px 0px',fontSize:'1.3rem'}}>
                  <Flex style={{}}>Last Week</Flex>
                  <Flex textAlign='left'>{currency(lastWeekTotal)}</Flex>
                  <Flex style={{
                    color: lastWeekTotal > lastYearLastWeek ? 'green' :
                           lastWeekTotal < lastYearLastWeek ? 'red' : 'gray'
                  }}>
                    {getChangeDisplay(lastWeekTotal, lastYearLastWeek)}
                  </Flex>
                </Flexed>
                <Flexed style={{padding:'5px 0px',fontSize:'1.3rem'}}>
                  <Flex style={{}}>This Month</Flex>
                  <Flex textAlign='left'>{currency(thisMonthTotal)}</Flex>
                  <Flex style={{
                    color: thisMonthTotal > lastYearThisMonth ? 'green' :
                           thisMonthTotal < lastYearThisMonth ? 'red' : 'gray'
                  }}>
                    {getChangeDisplay(thisMonthTotal, lastYearThisMonth)}
                  </Flex>
                </Flexed>
                <Flexed style={{padding:'5px 0px',fontSize:'1.3rem'}}>
                  <Flex style={{}}>This Quarter</Flex>
                  <Flex textAlign='left'>{currency(thisQuarterTotal)}</Flex>
                  <Flex style={{
                    color: thisQuarterTotal > lastYearThisQuarter ? 'green' :
                           thisQuarterTotal < lastYearThisQuarter ? 'red' : 'gray'
                  }}>
                    {getChangeDisplay(thisQuarterTotal, lastYearThisQuarter)}
                  </Flex>
                </Flexed>
                <Flexed style={{padding:'5px 0px',fontSize:'1.3rem'}}>
                  <Flex style={{}}>YTD </Flex>
                  <Flex textAlign='left'>{currency(thisYearTotal)}</Flex>
                  <Flex style={{
                    color: thisYearTotal > lastYearYTD ? 'green' :
                           thisYearTotal < lastYearYTD ? 'red' : 'gray'
                  }}>
                    {getChangeDisplay(thisYearTotal, lastYearYTD)}
                  </Flex>
                </Flexed>
              </Flex>

              <Flex>
                <Flexed style={{padding:'5px 0px',fontSize:'1.3rem'}}>
                  <Flex style={{}}>This Week</Flex>
                  <Flex textAlign='left'>{currency(lastYearThisWeek)}</Flex>
                  <Flex></Flex>
                </Flexed>
                <Flexed style={{padding:'5px 0px',fontSize:'1.3rem'}}>
                  <Flex style={{}}>Last Week</Flex>
                  <Flex textAlign='left'>{currency(lastYearLastWeek)}</Flex>
                  <Flex></Flex>
                </Flexed>
                <Flexed style={{padding:'5px 0px',fontSize:'1.3rem'}}>
                  <Flex style={{}}>This Month</Flex>
                  <Flex textAlign='left'>{currency(lastYearThisMonth)}</Flex>
                  <Flex></Flex>
                </Flexed>
                <Flexed style={{padding:'5px 0px',fontSize:'1.3rem'}}>
                  <Flex style={{}}>This Quarter</Flex>
                  <Flex textAlign='left'>{currency(lastYearThisQuarter)}</Flex>
                  <Flex></Flex>
                </Flexed>
                <Flexed style={{padding:'5px 0px',fontSize:'1.3rem'}}>
                  <Flex style={{}}>YTD </Flex>
                  <Flex textAlign='left'>{currency(lastYearYTD)}</Flex>
                  <Flex></Flex>
                </Flexed>
              </Flex>
            </Flexed>
          </div>
       </> : <p>You are not authorized to see this persons sales report.</p>}
         
        </TabPanel>
      </Tabs>
    </MainWrap>
  );
};

export default SalesDashboard;